// extracted by mini-css-extract-plugin
export default {"Container":"Container_Container__mRXZX","Shadow":"Container_Shadow__Fu86m","append-animate":"Container_append-animate__kCYD+"};